import { useEffect, useState } from 'react';

/**
 * Tracks the rendered width of an element.
 *
 * @param element - Measured element, or `null` before it mounts.
 * @returns The element width in CSS pixels, or 0 until it is measured.
 */
export const useElementWidth = (element: Element | null): number => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (!element) {
      return undefined;
    }

    setWidth(element.getBoundingClientRect().width);
    if (typeof ResizeObserver === 'undefined') {
      return undefined;
    }

    const observer = new ResizeObserver((entries) => {
      const entry = entries.at(0);
      if (entry) {
        setWidth(entry.contentRect.width);
      }
    });
    observer.observe(element);

    return () => observer.disconnect();
  }, [element]);

  return width;
};
